import { defer } from 'react-router-dom'
import { mercuryApi } from '$api'
import { stripLegacyPackageRefPrefix } from '../../../_common/packageRef'

export default async function loader({ params }) {
  const packageId = stripLegacyPackageRefPrefix(params.packageId)

  const ruleDetail = mercuryApi
    .get(`/pay-rules/packages/${packageId}`)
    .then((p) => {
      // get the specific rule we have routed to from the whole package
      return p.rules.find((rule) => rule.id === params.ruleId)
    })

  return defer({
    data: ruleDetail,
  })
}
